import React from 'react';
import { useNavigate } from 'react-router-dom';

// Back button used on auth pages (Login, Register, ForgotPassword, ResetPassword,
// VerifyEmail). Pattern ported from the Trailers detail-page backLink but with
// the text changed to just "Back" and behavior = navigate(-1) per Hotfix 8.1 /
// 15.1 spec.
//
// Inline styled because Auth.module.css wasn't available at the time this shipped;
// if you want to move these styles into a proper module class later, that's a
// safe follow-up.
export default function BackButton() {
  const navigate = useNavigate();
  return (
    <button
      type="button"
      onClick={() => navigate(-1)}
      aria-label="Go back"
      style={{
        alignSelf: 'flex-start',
        background: 'none',
        border: 'none',
        color: 'var(--white)',
        cursor: 'pointer',
        fontFamily: 'inherit',
        fontSize: 16,
        fontWeight: 500,
        padding: '6px 10px',
        margin: '20px 0 8px 20px',
        display: 'inline-flex',
        alignItems: 'center',
        gap: 8,
        borderRadius: 6,
        transition: 'opacity 0.15s ease',
      }}
      onMouseEnter={e => { e.currentTarget.style.opacity = '0.75'; }}
      onMouseLeave={e => { e.currentTarget.style.opacity = '1'; }}
    >
      <span aria-hidden="true" style={{ fontSize: 18, lineHeight: 1 }}>←</span>
      <span>Back</span>
    </button>
  );
}
